module Client.Storage

open Fable.SimpleJson

let [<Literal>] USER_STORAGE_KEY = "linksManagerUser"
let [<Literal>] CP_USER_STORAGE_KEY = "carePathUser"
let [<Literal>] SEEN_NEWS_ARTICLES_STORAGE_KEY = "seenNewsArticles"

let inline store key value =
    async {
        do Browser.WebStorage.localStorage.setItem (key, Json.stringify value)
    }

let inline remove key =
    async {
        do Browser.WebStorage.localStorage.removeItem key
    }

let inline get<'t> key =
    Browser.WebStorage.localStorage.getItem key |> Json.parseAs<'t>

let inline tryGet<'t> key =
    let ret = Browser.WebStorage.localStorage.getItem key
    if isNull ret then None
    else
        match ret |> Json.tryParseAs<'t> with
        | Result.Ok x -> Some x
        | Result.Error _ -> None